/*=========================================================================================
  File Name: moduleHomeActions.js
  Description: Home Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: GetBoarded UI Template
  Author: GetBoarded
  Author URL: https://www.getboarded.com
==========================================================================================*/

import axios from "@/axios.js";
import store from "@/store/store.js";

export default {

  getAllCompetencyDesc({commit}, query) {
    return new Promise((resolve, reject) => {
      // const params = {query: {$sort: {createdAt: -1}}}
      store.dispatch("trainee-competencies/find", query).then(res => {
        resolve(res)
      }).catch(err => {
        console.log("store error glc", err)
        reject(err)
      })
    })
  },

  getAllCharacteristics({ commit }) {
    return new Promise((resolve, reject) => {
      store
        .dispatch("characteristic-list/find")
        .then(res => {
          resolve(res.data);
        })
        .catch(err => reject(err));
    });
  },

  getAllCompetencies({ commit }) {
    return new Promise((resolve, reject) => {
      store
        .dispatch("competency-list/find")
        .then(res => {
          resolve(res.data);
        })
        .catch(err => reject(err));
    });
  },

  getAllProgressMeasures({ commit }) {
    return new Promise((resolve, reject) => {
      store
        .dispatch("progress-measure-list/find")
        .then(res => {
          resolve(res.data);
        })
        .catch(err => reject(err));
    });
  },

  addSelectedCharacteristic({ commit }, characteristic) {
    return new Promise((resolve, reject) => {
      commit("ADD_SELECTED_CHARACTERISTIC", characteristic);
      commit("ADD_SKILL_STEP", 2);
      resolve(characteristic);
      return characteristic; // resolve
    });
  },

  removeSelectedCharacteristic({ commit }, characteristic) {
    return new Promise((resolve, reject) => {
      commit("REMOVE_SELECTED_CHARACTERISTIC", characteristic);
      resolve(characteristic);
      return characteristic; // resolve
    });
  },

  getCompetency({ commit }, compId) {
    return new Promise((resolve, reject) => {
      store
        .dispatch("trainee-competencies/get", compId)
        .then(res => {
          // commit("SET_SELECTED_COMPETENCY", competency);
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  getCompetencyFromList({ commit }, compId) {
    return new Promise((resolve, reject) => {
      store
        .dispatch("competency-list/get", compId)
        .then(res => {
          // commit("SET_SELECTED_COMPETENCY", competency);
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  setSelectedCompetency({ commit }, competency) {
    return new Promise((resolve, reject) => {
      commit("SET_SELECTED_COMPETENCY", competency);
      resolve(competency)
      return competency; // resolve
    });
  },

  setInitialLevel({ commit }, initialLevelObj) {
    return new Promise((resolve, reject) => {
      commit("SET_INITIAL_LEVEL", initialLevelObj[0]);
      commit("SET_INITIAL_LEVEL_TEXT", initialLevelObj[1]);
      resolve(initialLevelObj);
      return initialLevelObj;
    });
  },

  setTrainingDuration({ commit }, trainingDuration) {
    return new Promise((resolve, reject) => {
      commit("SET_TRAINING_DURATION", trainingDuration);
      return trainingDuration; // resolve(td)
    });
  },

  setProgressMeasure({ commit }, progressMeasure) {
    return new Promise((resolve, reject) => {
      commit("SET_PROGRESS_MEASURE", progressMeasure);
      return progressMeasure; // resolve(td)
    });
  },

  saveUserSkill({ commit }, userSkill) {
    return new Promise((resolve, reject) => {
      store
        .dispatch("trainee-competencies/create", userSkill)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          console.log("error saving skill", err);
          reject(err);
        });
    });
  }
};
